import { render, staticRenderFns } from "./falseAlarmuser.vue?vue&type=template&id=65556d9c&"
import script from "./falseAlarmuser.vue?vue&type=script&lang=js&"
export * from "./falseAlarmuser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports